import IHelpButton from './IHelpButton';

export default IHelpButton;



// WEBPACK FOOTER //
// ./src/components/primitives/IHelpButton/index.jsx